import * as UI from "../../../../modules/ui-kit";

export default function AddressFieldSet(props) {
    const { onChange, value } = props;

    const writer = {
        street: (street: string) => onChange({ ...value, street }),
        city: (city: string) => onChange({ ...value, city }),
        zipCode: (zipCode: string) => onChange({ ...value, zipCode }),
        country: (country: string) => onChange({ ...value, country }),
    };

    return (
        <UI.Field>
            <UI.FieldLabel>Address</UI.FieldLabel>
            <UI.Field>
                <UI.FieldLabel>Street</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.street }
                    placeholder="Street"
                    value={ value?.street ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>City</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.city }
                    placeholder="City"
                    value={ value?.city ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Postal code</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.zipCode }
                    placeholder="Postal code"
                    value={ value?.zipCode ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Country</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.country }
                    placeholder="Country"
                    value={ value?.country ?? "" }
                />
            </UI.Field>
        </UI.Field>
    );
}
